import queryString from 'query-string';

import {REQUEST_TIMEOUT_LIMIT} from '../../services/constants';
import {requestTimeoutLimit} from '../../services/request-timeout-limit';

const ERRORS = {
  default: {
    message: 'Server unavailable. Please check your connection and try again.'
  },
  timeout: {
    type: 'timeout',
    message: `Request canceled, timeout of ${REQUEST_TIMEOUT_LIMIT}ms exceeded`
  }
};

export default class ApiClient {
  get(url, params) {
    return this.request({
      url,
      params,
      method: 'GET'
    });
  }

  post(url, payload = {}, accessToken = null) {
    return this.request({
      url,
      method: 'POST',
      body: payload,
      accessToken
    });
  }

  request({url, method, params = {}, body, accessToken}) {
    const authorizationHeader = accessToken ? {Authorization: `Bearer ${accessToken}`} : {};
    const query = Object.keys(params).length ? `?${queryString.stringify(params, {arrayFormat: 'comma'})}` : '';
    const fullUrl = `${window.Site.financeDomain}${url}${query}`;

    return fetch(
      fullUrl,
      {
        method,
        headers: {
          'Content-Type': 'application/json',
          ...authorizationHeader
        },
        body: method !== 'GET' && body ? JSON.stringify(body) : undefined, /* eslint-disable-line */
        signal: requestTimeoutLimit()
      }
    )
      .then(response => response.json())
      .then(response => {
        if (response.error) {
          throw response;
        }
        return response;
      })
      .catch(err => {
        // catch timeout request error
        if (err.name === 'AbortError') {
          throw ERRORS.timeout;
        }
        // catch other errors
        if (err.error) {
          throw err;
        }
        // Show default error
        throw ERRORS.default;
      });
  }
}
